import {
  FETCH_COMMENT_REQUEST,
  FETCH_COMMENT_SUCCESS,
  FETCH_COMMENT_FAILURE,
  UPDATE_COMMENT_REQUEST,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_FAILURE,
} from "./actionType";

import { Comment, FirebaseComment } from "../../core/entities/comment";

export const fetchComments = (applicantId: string) => ({
  type: FETCH_COMMENT_REQUEST,
  payload: { applicantId },
});

export const fetchCommentSuccess = (comments: FirebaseComment) => ({
  type: FETCH_COMMENT_SUCCESS,
  payload: { comments },
});

export const fetchCommentFailure = (error: string) => ({
  type: FETCH_COMMENT_FAILURE,
  payload: { error },
});

export const updateCommentRequest = (
  applicantId: string,
  id: string,
  data: Comment[]
) => ({
  type: UPDATE_COMMENT_REQUEST,
  payload: { applicantId, id, data },
});

export const updateCommentSuccess = () => ({
  type: UPDATE_COMMENT_SUCCESS,
});

export const updateCommentFailure = (error: string) => ({
  type: UPDATE_COMMENT_FAILURE,
  payload: { error },
});
